<template>
  <div class="fill-height of-y d-flex align-center mr-2" >
    <div class="ml-4 text-h5 font-weight-light">
      Devices
    </div>
    <div class="flex-grow-1">
      <slot></slot>
    </div>

    <v-btn
      v-if="this.$store.state.ref.devices.tabIndex === 2 && unassignedMSTeamsDevices.length > 0"
      outlined
      color="primary"
      class="mx-2"
      small
      :disabled="loadingMSTeamsAutoAssign || unassignedMSTeamsDevices.length <= 0"
      :loading="loadingMSTeamsAutoAssign"
      @click="autoAssignMsTeamsDevices"
    >
      Auto Assign MS Teams Devices
    </v-btn>

    <div style="width: 300px">
      <v-text-field
        placeholder="Search"
        hide-details
        class="pa-0 ma-0 mx-2"
        color="primary"
        prepend-inner-icon="mdi-magnify"
        solo
        dense
        v-model="$store.state.ref.devices.filterStr"
      ></v-text-field>
    </div>
    <v-btn
      icon
      color="primary"
      class="mx-2"
      small
      @click="downloadSummary"
    >
      <v-icon>mdi-microsoft-excel</v-icon>
    </v-btn>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

const xls = require('json-as-xlsx');
export default {
  components: {

  },
  props: {
    shown: Boolean
  },
  data() {
    return {
      loadingMSTeamsAutoAssign: false,
    }
  },
  watch: {

  },
  methods: {
    downloadSummary() {

      const devices = this.$store.state.devices.filter(v => !v.userDevice)


      const downloadList = []
      for (const device of devices) {
        const obj = {
          device,
          employee: this.$store.getters.employeeMap.get(device.employeeId) || null,
        }
        obj.team = this.$store.getters.teamMap.get(obj.employee?.teamId) || null
        downloadList.push(obj)
      }

      const cols = [
        {label: 'Device', value: 'device'},
        {label: 'Device Type', value: 'deviceType'},
        {label: 'Device Status', value: 'deviceStatus'},
        {label: 'Employee', value: 'employee'},
        {label: 'Employee Status', value: 'employeeStatus'},
        {label: 'Team', value: 'team'}
      ]

      const deviceRows = downloadList.map(v => ({
        device: v.device.name,
        deviceType: v.device.phone ? 'Phone' : (v.device.o365TenantUser ? 'Microsoft Teams User' : 'Computer') ,
        deviceStatus: v.device.disabled ? 'Disabled' : 'Enabled',
        employee: v.employee?.name || '',
        employeeStatus: v.employee ? (v.employee?.disabled ? 'Disabled' : 'Enabled') : '',
        team: v.team?.name || ''
      }))

      let data = [{
        sheet: 'Devices',
        columns: cols,
        content: deviceRows
      }]

      let settings = {
        fileName: 'Devices export',
      }

      xls(data, settings)
    },
    async autoAssignMsTeamsDevices() {
      try {
        this.loadingMSTeamsAutoAssign = true;

        this.latestVersions = await this.$newReq(
          'POST',
          'devices/autoAssignMSTeams',
          {
            unassignedMSTeamsDevices: this.unassignedMSTeamsDevices
          }
        );

        this.$snack.info('Devices Linked');

      } catch (e) {
        console.log(e);
        this.$snack.netWorkError();
      } finally {
        this.loadingMSTeamsAutoAssign = false;
      }
    },
  },
  computed: {
    ...mapGetters(['devices', 'employeesRef', 'devicesWithAccess']),
    unassignedMSTeamsDevices() {
      return this.devicesWithAccess.filter(device => device.o365TenantUser && !device.employeeId);
    }
  },
}
</script>

<style scoped>

</style>